import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as ErrorSVG } from "../../../../../images/svg/public/order/error.svg";
import { ReactComponent as SuccessSVG } from "../../../../../images/svg/public/order/success.svg";
import { OrderTransactionStatus } from "../../../../../services/Api/Public/types";

interface Props {
	show: boolean;
	onHide: () => void;
	status: OrderTransactionStatus;
}

const PaymentInfoModal = ({ show, onHide, status }: Props) => {
	const { t } = useTranslation();
	const isMobile = useWindowSize().isMobile;

	const getStatusIcon = () => {
		switch (status) {
			case OrderTransactionStatus.ERROR: {
				return <ErrorSVG />;
			}
			case OrderTransactionStatus.SUCCESS: {
				return <SuccessSVG />;
			}
			default:
				return <></>;
		}
	};

	const getTitle = () => {
		switch (status) {
			case OrderTransactionStatus.ERROR: {
				return t("modules.e_order.field.payment_failed.title");
			}
			case OrderTransactionStatus.SUCCESS: {
				return t("modules.e_order.field.payment_success.title");
			}
			default:
				return "";
		}
	};

	return (
		<Modal
			className="payment-info-modal"
			show={show}
			onHide={onHide}
			aria-labelledby="payment-info-modal-title"
			centered={!isMobile}
		>
			<Modal.Header>
				<button
					onClick={onHide}
					className="btn-close"
					data-bs-dismiss="modal"
					aria-label={t("lib:common.action.close")}
				/>
			</Modal.Header>
			<Modal.Body>
				<>
					<div className="payment-info-modal-header">
						{getStatusIcon()}
						<h1 id="payment-info-modal-title">{getTitle()}</h1>
					</div>
					<div className="payment-info-modal-footer">
						<Button variant="outline-secondary" className="w-100" onClick={onHide}>
							{t("modules.e_order.action.ok.title")}
						</Button>
					</div>
				</>
			</Modal.Body>
		</Modal>
	);
};

export default PaymentInfoModal;
